<template>
  <section aria-label="Veranstaltungen Suche">
    <div class="form-wrapper green-inputs mb-5">
      <div class="frame-dash-underlined mb-3">
        <div class="row pb-4 align-items-center">
          <div class="col-12 col-md-5">
            <h2 class="h5 mb-0">VERANSTALTUNG FINDEN</h2>
          </div>
          <div class="col-12 col-md-7">
            <div class="row align-items-center">
              <div class="col-md-3 col-12 my-4 my-md-0"></div>
              <div class="col-md-9 col-12">
                <div class="input-group floating-icon pill rounded-pill">
                  <label for="freetext" style="line-height: 2.5"
                    ><span class="sr-only">Veranstaltungen nach </span
                    >Freitext<span class="sr-only"> suchen</span>:</label
                  >
                  <input
                    class="form-control"
                    style="
                      max-width: 12em;
                      border-radius: 999px 0px 0px 999px !important;
                    "
                    @input="throttleUpdateValue($event, 's')"
                    :value="dataStore.params.s"
                    id="freetext"
                  />
                  <span class="input-group-text">
                    <i class="fa fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-4">
        <div
          class="col-12 col-md-6 d-md-flex mb-4 mb-md-0 justify-content-between align-items-center"
        >
          <label
            for="Veranstaltungsart"
            class="form-label d-block d-md-inline-block"
            >Veranstaltungsart:</label
          >
          <select
            id="Veranstaltungsart"
            class="form-select green-arrow withshadow twocorners"
            @input="updateValue($event, 'fbkat')"
            :value="dataStore.params.fbkat"
          >
            <option v-for="op in veranopts" :value="op.code">
              {{ op.value }}
            </option>
          </select>
        </div>
        <div
          class="col-12 col-md-6 d-md-flex mb-4 mb-md-0 justify-content-between align-items-center"
        >
          <label for="Zielgruppe" class="form-label">Zielgruppe:</label>
          <select
            id="Zielgruppe"
            class="form-select green-arrow withshadow twocorners"
            @input="updateValue($event, 'zg')"
            :value="dataStore.params.zg"
          >
            <option v-for="op in zielopts" :value="op.code">
              {{ op.value }}
            </option>
          </select>
        </div>
      </div>
      <div class="row my-4">
        <div class="col-12 col-lg-6 d-md-flex align-items-center mb-3 mb-md-0">
          <div class="form-label mb-0 fw-bold me-3">Veranstalter:</div>
          <div class="d-flex">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="Veranstalter"
                id="Veranstalter_0"
                value="-1"
                checked
                @input="updateValue($event, 'veranstalter')"
                :value="dataStore.params.veranstalter"
              />
              <label for="Veranstalter_0" class="form-check-label"
                >Alle <span class="sr-only">Veranstalter</span></label
              >
            </div>
          </div>
          <div class="d-flex">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="Veranstalter"
                id="Veranstalter_1"
                value="N"
                @input="updateValue($event, 'veranstalter')"
                :value="dataStore.params.veranstalter"
              />
              <label for="Veranstalter_1" class="form-check-label"
                ><span class="sr-only">Veranstalter: </span
                >Apothekerkammer</label
              >
            </div>
          </div>
          <div class="d-flex">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="Veranstalter"
                id="Veranstalter_2"
                value="J"
                @input="updateValue($event, 'veranstalter')"
                :value="dataStore.params.veranstalter"
              />
              <label for="Veranstalter_2" class="form-check-label"
                ><span class="sr-only">Veranstalter:</span>
                Fremdveranstalter</label
              >
            </div>
          </div>
        </div>
        <div
          class="col-12 col-lg-6 d-md-flex mb-4 mb-md-0 justify-content-between align-items-center pe-lg-0"
        >
          <div class="row w-100 pe-lg-0">
            <div
              class="col-md-6 d-flex justify-content-between align-items-center mb-3 mb-md-0"
            >
              <label
                for="datumvon"
                class="form_label d-flex align-items-center text-nowrap"
                style="min-width: 2em"
                ><span class="sr-only">Veranstaltungssuche, </span>Von
                <span class="sr-only">Datum</span>:<span
                  class="d-none d-md-inline-block"
                ></span
              ></label>
              <VueDatePicker
                locale="de"
                v-model="fromDateModel"
                ref="fromDateRef"
                @update:model-value="updateDateModel($event, 'von_dat')"
                cancelText="abbrechen"
                selectText="auswählen"
                model-type="dd/MM/yyyy"
                :clearable="false"
                :enable-time-picker="false"
                :format-locale="de"
                format="dd/MM/yyyy"
                :auto-apply="true"
                input-class-name="date-input"
                menu-class-name="date-menu"
                :min-date="new Date()"
              >
                <template
                  #dp-input="{
                    value,
                    onInput,
                    onEnter,
                    onTab,
                    onClear,
                    onBlur,
                    onKeypress,
                    onPaste,
                    isMenuOpen,
                  }"
                >
                  <div
                    class="input-group withshadow twocorners green-input-text"
                  >
                    <input id="datumvon" class="form-control unstyled"
                    style="max-width: 12em" :value="fromDateModel"
                    ref="fromDateRef" placeholder = TT/MM/JJJJ />
                    <span class="input-group-text">
                      <button
                        class="fas fa-times-circle nobutt"
                        @click="(event) => emptyDatePicker('von_dat', event)"
                        aria-label="Feld Von-Datum zurücksetzen"
                      ></button>
                    </span>
                  </div>
                </template>
              </VueDatePicker>
            </div>

            <div
              class="col-md-6 d-flex justify-content-between align-items-center pe-lg-0"
            >
              <label
                for="datumbis"
                class="form_label d-flex align-items-center text-nowrap"
                style="min-width: 2em"
                >Bis <span class="sr-only">Datum</span>:<span
                  class="d-none d-md-inline-block"
                ></span
              ></label>
              <VueDatePicker
                locale="de"
                v-model="toDateModel"
                ref="toDateRef"
                @update:model-value="updateDateModel($event, 'bis_dat')"
                cancelText="abbrechen"
                selectText="auswählen"
                model-type="dd/MM/yyyy"
                :clearable="false"
                :enable-time-picker="false"
                :format-locale="de"
                format="dd/MM/yyyy"
                :auto-apply="true"
                input-class-name="date-input"
                menu-class-name="date-menu"
                :min-date="minToDate"
              >
                <template
                  #dp-input="{
                    value,
                    onInput,
                    onEnter,
                    onTab,
                    onClear,
                    onBlur,
                    onKeypress,
                    onPaste,
                    isMenuOpen,
                  }"
                >
                  <div
                    class="input-group withshadow twocorners green-input-text"
                  >
                    <input id="datumbis" class="form-control unstyled"
                    style="max-width: 12em" :value="toDateModel" ref="toDateRef"
                    placeholder = TT/MM/JJJJ />
                    <span class="input-group-text">
                      <button
                        class="fas fa-times-circle nobutt"
                        @click="(event) => emptyDatePicker('bis_dat', event)"
                        aria-label="Feld Bis-Datum zurücksetzen"
                      ></button>
                    </span>
                  </div>
                </template>
              </VueDatePicker>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-4">
        <div class="col-12 col-md-6 text-start">
          <div class="d-inline-block">
            <div
              class="input-group floating-icon pill ophover"
              style="max-width: 17em"
            >
              <button
                class="form-control text-center fullpill"
                @click="resetFilters()"
              >
                <i class="fas fa-times text-red"></i> Alle Filter zurücksetzen
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 text-md-end mt-3 mt-md-0">
          <div class="d-inline-block">
            <div class="input-group floating-icon pill ophover">
              <button
                class="form-control text-center fullpill bg-green"
                @click="callApi(true)"
                style="max-width: 14em !important; min-width: 10em"
              >
                Suchen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, watch, reactive, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useDataStore } from "@/store/";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { debugLog } from "@/shared/utils";
import { eventListeners } from "@popperjs/core";

const throttle = require("lodash/throttle");
const dataStore = useDataStore();
const loading = ref(false);
const { params, page } = storeToRefs(dataStore);
const fromDateRef = ref();
const toDateRef = ref();
const fromDateModel = ref();
const toDateModel = ref();
const minToDate = ref(new Date());

const emptyFieldParams = {
  s: "",
  fbkat: "-1",
  zg: "*",
  veranstalter: "-1",
  freePlaces: "",
  von_dat: "",
  bis_dat: "",
};

dataStore.setParams({ ...emptyFieldParams });

const resetFilters = () => {
  dataStore.setParams({ ...emptyFieldParams });
  fromDateModel.value = "";
  toDateModel.value = "";
};

const updateValue = (e, key) => {
  dataStore.setParams({ ...dataStore.params, [key]: e.target.value });
  dataStore.setFormLoad(true);
};

const throttleUpdateValue = throttle((e, key) => {
  dataStore.setParams({ ...dataStore.params, [key]: e.target.value });
}, 10);

const updateDateModel = (value, key) => {
  const dateAr = value.split("/");
  const newVal = dateAr[2] + "-" + dateAr[1] + "-" + dateAr[0];
  dataStore.setParams({ ...dataStore.params, [key]: newVal });
  if (key == "von_dat") {
    emptyDatePicker("bis_date", {
      stopPropagation: () => {},
      preventDefault: () => {},
    });
    minToDate.value = new Date(newVal);
  }
};

const callApi = (
  resetPage = false,
  additionalCallbacks = { afterEnd: () => {} }
) => {
  if (resetPage) {
    dataStore.setPage(1);
    dataStore.setParams({ ...dataStore.params, page: 1 });
  }
  dataStore.callApi({
    beforeStart: () => {
      dataStore.loading.veranstaltungen = true;
    },
    afterEnd: () => {
      dataStore.loading.veranstaltungen = false;
      document.querySelector(".veranstaltungen .form-wrapper").scrollIntoView();
      additionalCallbacks.afterEnd();
    },
  });
};

// PAGER
watch(page, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    callApi();
  }
});

onMounted(() => {
  dataStore.setUrl(process.env.VUE_APP_API_BASE + apiPointOut);
  callApi(false, {
    afterEnd: () => {
      dataStore.setFormLoad(true);
      dataStore.setFirstLoad(false);
    },
  });
});

const emptyDatePicker = (paramKey, event) => {
  if (event) {
    event?.stopPropagation();
    event?.preventDefault();
  }
  dataStore.params[paramKey] = "";
  if (paramKey == "von_dat") {
    fromDateModel.value = "";
    minToDate.value = new Date();
  } else {
    toDateModel.value = "";
  }
};

const optionsUp =
  typeof options === "undefined"
    ? '{"veranopts":[{"code":"-1","value":"Alle Ma\u00dfnahmen"},{"code":"1a","value":"1a) Seminar, Workshop, Praktikum"},{"code":"1b","value":"1b) Pharmazeutischer Qualit\u00e4tszirkel"},{"code":"2","value":"2) Kongress"},{"code":"3","value":"3) Live-Vortrag"}],"zielopts":[{"code":"*","value":"Alle Zielgruppen"},{"code":"01","value":"Apotheker\/in"},{"code":"02","value":"Apotheker\/in in Weiterbildung"},{"code":"03","value":"Apotheker\/in mit befristeter Berufserlaubnis"},{"code":"04","value":"PTA"},{"code":"05","value":"PTA in Ausbildung"},{"code":"06","value":"Pharmazeut\/in im Praktikum (PhiP) "},{"code":"07","value":"Pharmaziestudent\/in"},{"code":"08","value":"Pharmazieingenieur\/in"},{"code":"09","value":"Apothekerassistent\/in, Apothekenassistent\/in, pharmazeutische\/r Assistent\/in"},{"code":"12","value":"Arzt\/\u00c4rztin"},{"code":"13","value":"PKA"},{"code":"14","value":"PKA in Ausbildung "},{"code":"15","value":"Sonstige"}]}'
    : options;
const { veranopts, zielopts } = JSON.parse(optionsUp);

const apiPointOut =
  typeof apiPoint === "undefined"
    ? "http://akberlin12:8888/fuer-mitglieder/aus-fort-und-weiterbildungaus-fort-und-weiterbildung/forbildung/veranstaltungen?tx_apis_calluniplus%5Baction%5D=callUniplus&tx_apis_calluniplus%5Bcontroller%5D=X3&tx_apis_calluniplus%5Bpath%5D=seminarwesen%2Fkurse%2F&type=871&cHash=7ba794e3bbef8570902b47cb1c8fe9a2"
    : apiPoint;
</script>
